import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getAtsJobCreate } from '@/store/atsJobCreate';
import { NoteTakerField } from './NoteTakerField';

interface NoteTakerConfig {
  name?: string;
  props?: {
    name: string;
    isNoteTakerMandatory: boolean;
  };
  [key: string]: any;
}

interface NoteTakerConfigProps {
  config?: Partial<NoteTakerConfig>;
}

export const useNoteTakerConfig = ({ config }: NoteTakerConfigProps = {}) => {
  const { name = 'enable_note_taker', ...overRides } = config ?? {};

  const { currentJob = {} } = useSelector(getAtsJobCreate, shallowEqual);

  const isNoteTakerMandatory = currentJob?.data?.note_taker?.mandatory ?? false;

  const formConfig = useMemo(
    () => ({
      name,
      isConditional: true,
      conditionConfig: {
        type: 'or',
        conditions: [
          { field: 'location', value: 'zoom' },
          { field: 'location', value: 'google_meet' },
          { field: 'location', value: 'teams' },
        ],
      },
      type: 'custom',
      Field: NoteTakerField,
      props: {
        name,
        isNoteTakerMandatory,
      },
      ...overRides,
    }),
    [name, isNoteTakerMandatory, overRides]
  );

  return formConfig;
};
